'use client';

import Button, { EButtonVariants } from '@/components/button/Button';
import { IFormSubmitButtonProps } from './types';
import { MouseEvent } from 'react';
import clsx from 'clsx/lite';

export default function FormSubmitButton(props: IFormSubmitButtonProps) {
  // action & asset will be passed in from the Form component
  const { label, asset, action, alignment, theme } = props;

  function onSubmit(event: MouseEvent<HTMLButtonElement>) {
    const form = event.currentTarget.form;
    const isFormValid = form?.checkValidity();

    if (isFormValid && action === 'download-file' && asset?.filename) {
      window.open(asset?.filename, '_blank')?.focus();
    }
  }

  return (
    <Button
      variant={EButtonVariants.PrimaryButton}
      buttonType='submit'
      className={clsx(
        'w-fit',
        alignment === 'center' && 'self-center',
        alignment === 'right' && 'self-end',
        theme === 'small-rounded-border' && 'rounded-lg'
      )}
      onClick={onSubmit}
    >
      {label}
    </Button>
  );
}
